import React, { FC, memo, ReactNode, useEffect } from 'react'

import clsx from 'clsx'

import { GlobalLoadingLink } from 'src/components/atoms/dataDisplays/GlobalLoadingLink'
import { GlobalNavigationItem, NavigationType } from 'src/components/organisms'

import { useAuthority, useGetProfile } from 'src/hooks'
import { useRenderStatus } from 'src/hooks/useRenderStatus'
import { Routes } from 'src/routes'

type Props = {
  selectedNavigation?: NavigationType
  className?: string
}

function ListItem({ className, children }: { className?: string; children: ReactNode }) {
  return <li className={clsx('tw-mt-[1.4rem] first:tw-mt-0', className)}>{children}</li>
}

export const GlobalNavigation: FC<Props> = memo(({ selectedNavigation, className }) => {
  const { profile, loading } = useGetProfile()
  const { canManageSecurity } = useAuthority()
  const { updateGlobalNavigationRenderStatus } = useRenderStatus()

  useEffect(() => {
    updateGlobalNavigationRenderStatus(!loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const { canManageUser } = useAuthority()

  return (
    <div className={className}>
      {profile && (
        <ul>
          <ListItem>
            <GlobalLoadingLink href={Routes.Dashboard.path}>
              <GlobalNavigationItem
                isSelected={selectedNavigation === 'dashboard'}
                navigationType="dashboard"
              />
            </GlobalLoadingLink>
          </ListItem>
          <ListItem>
            <GlobalLoadingLink href={Routes.ProjectTop.path}>
              <GlobalNavigationItem
                isSelected={selectedNavigation === 'project'}
                navigationType="project"
              />
            </GlobalLoadingLink>
          </ListItem>
          {canManageUser && (
            <ListItem>
              <GlobalLoadingLink href={Routes.UserList.path}>
                <GlobalNavigationItem
                  isSelected={selectedNavigation === 'user'}
                  navigationType="user"
                />
              </GlobalLoadingLink>
            </ListItem>
          )}
          {canManageSecurity && (
            <ListItem>
              <GlobalLoadingLink href={Routes.Setting.path}>
                <GlobalNavigationItem
                  isSelected={selectedNavigation === 'setting'}
                  navigationType="setting"
                />
              </GlobalLoadingLink>
            </ListItem>
          )}
          <ListItem>
            <GlobalLoadingLink href={Routes.Account.path}>
              <GlobalNavigationItem
                isSelected={selectedNavigation === 'mypage'}
                navigationType="mypage"
              />
            </GlobalLoadingLink>
          </ListItem>
        </ul>
      )}
    </div>
  )
})
